import { EDIT_LISTING_ADDITIONAL_RULES,
         CLOSE_LISTING_ADDITIONAL_RULES,
         PENDING_SUBMIT_LISTING_ADDITIONAL_RULES,
         COMPLETE_SUBMIT_LISTING_ADDITIONAL_RULES,
         FAILED_SUBMIT_LISTING_ADDITIONAL_RULES
    } from "./mlTypes"


const initialState = {
    pendingsubmit: false,
    failedsubmit: false,
    completesubmit: false,
    propertyadditionalrulesediting: false
}


const mlListingAdditionalRules = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_LISTING_ADDITIONAL_RULES: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyadditionalrulesediting: true
        }

        case CLOSE_LISTING_ADDITIONAL_RULES: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyadditionalrulesediting: false
        }

        case PENDING_SUBMIT_LISTING_ADDITIONAL_RULES: return {
            ...state,
            pendingsubmit: true,
            failedsubmit: false,
            completesubmit: false
        }

        case COMPLETE_SUBMIT_LISTING_ADDITIONAL_RULES: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: true
        }
        
        case FAILED_SUBMIT_LISTING_ADDITIONAL_RULES: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: true,
            completesubmit: true
        }
    
        default: return state
    }
}

export default mlListingAdditionalRules